import { createAction } from 'typesafe-actions';

import { SetPickTourPagePayload } from './pickTourPage.types';

export const setPickTourPage = createAction('SET_PICK_TOUR_PAGE')<SetPickTourPagePayload>();
